import { render, staticRenderFns } from "./PostAuthor.vue?vue&type=template&id=640e4914&"
import script from "./PostAuthor.vue?vue&type=script&lang=js&"
export * from "./PostAuthor.vue?vue&type=script&lang=js&"
import style0 from "./PostAuthor.vue?vue&type=style&index=0&id=640e4914&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports